module.exports = __webpack_public_path__ + "static/media/blue3.481a3ec0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/baby/blue3.svg
// module id = 1330
// module chunks = 31